/* Edenworth sticky add-to-basket bar (product pages). Settings: Brand style > Sticky add-to-basket bar. */
(function () {
  'use strict';
  function css() {
    if (document.getElementById('ew-sticky-css')) return;
    var s = document.createElement('style'); s.id = 'ew-sticky-css';
    s.textContent =
      '.ew-sb{position:fixed;left:0;right:0;bottom:0;z-index:90;background:rgba(255,255,255,.97);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border-top:1px solid var(--ew-line);box-shadow:0 -12px 30px -18px rgba(21,23,27,.25);transform:translateY(110%);transition:transform .35s cubic-bezier(.2,.8,.2,1)}' +
      '.ew-sb.is-on{transform:none}' +
      '.ew-sb__in{max-width:132rem;margin:0 auto;padding:1.2rem 4rem;display:flex;align-items:center;gap:2rem}' +
      '.ew-sb__img{width:5.6rem;height:5.6rem;border-radius:1rem;overflow:hidden;background:var(--ew-bg2);flex:none}' +
      '.ew-sb__img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.ew-sb__info{min-width:0;flex:1}' +
      '.ew-sb__name{font-family:var(--ew-serif);font-size:2.2rem;line-height:1.1;color:var(--ew-ink);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.ew-sb__meta{display:flex;align-items:center;gap:1rem;margin-top:.4rem;font-size:1.3rem;color:var(--ew-muted);white-space:nowrap}' +
      '.ew-sb__stars{color:var(--ew-gold);letter-spacing:.08em}' +
      '.ew-sb__dot{width:.4rem;height:.4rem;border-radius:50%;background:var(--ew-line)}' +
      '.ew-sb__price{display:flex;align-items:baseline;gap:.8rem;flex:none}' +
      '.ew-sb__now{font-family:var(--ew-serif);font-size:3rem;line-height:1;color:var(--ew-ink)}' +
      '.ew-sb__was{font-size:1.5rem;color:var(--ew-muted);opacity:.7}' +
      '.ew-sb__save{font-size:1.15rem;font-weight:700;letter-spacing:.06em;color:var(--ew-ink);background:color-mix(in srgb,var(--ew-gold) 40%,#fff);border-radius:99px;padding:.4rem .9rem}' +
      '.ew-sb__btn{flex:none;height:5.4rem;padding:0 3.2rem;border:0;border-radius:99px;background:var(--ew-ink);color:#fff;font:inherit;font-size:1.6rem;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:1rem;transition:opacity .2s}' +
      '.ew-sb__btn:hover{opacity:.9}.ew-sb__btn[disabled]{opacity:.5;cursor:default}' +
      '.ew-sb__btn svg{width:1.8rem;height:1.8rem}' +
      '.ew-sb__trust{font-size:1.2rem;color:var(--ew-muted);white-space:nowrap;display:flex;align-items:center;gap:.6rem}' +
      '.ew-sb__trust i{width:.7rem;height:.7rem;border-radius:50%;background:#2E7D4F;display:inline-block}' +
      '@media (max-width:1199px){.ew-sb__trust{display:none}}' +
      '@media (max-width:749px){' +
        '.ew-sb__in{padding:1rem 1.6rem calc(1rem + env(safe-area-inset-bottom));gap:1.2rem}' +
        '.ew-sb__img,.ew-sb__info,.ew-sb__save{display:none}' +
        '.ew-sb__price{flex-direction:column;align-items:flex-start;gap:.2rem}' +
        '.ew-sb__now{font-size:2.6rem}.ew-sb__was{font-size:1.3rem}' +
        '.ew-sb__btn{flex:1;justify-content:center;height:5.2rem;padding:0 1.6rem}' +
        '.ew-sb.no-m{display:none}' +
      '}';
    document.head.appendChild(s);
  }

  function txt(el) { return el ? el.textContent.trim() : ''; }

  function init() {
    var SET = window.EW_SET || {};
    if (SET.sticky === false) return;
    var pdp = document.querySelector('.ew-pdp');
    if (!pdp || document.querySelector('.ew-sb')) return;
    var label = SET.stickyButton || 'Add to basket';
    var trustTxt = SET.stickyTrust === undefined ? 'Free UK delivery · 30-day home trial' : SET.stickyTrust;
    var buy = pdp.querySelector('.ew-buy');
    var main = pdp.querySelector('.product-form__submit');
    if (!buy || !main) return;
    css();

    var rating = SET.stickyStars === false ? null : pdp.querySelector('.ew-rating a');
    var bar = document.createElement('div');
    bar.className = 'ew-sb' + (SET.stickyMobile === false ? ' no-m' : ''); bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ew-sb__in">' +
        '<div class="ew-sb__img"><img alt=""></div>' +
        '<div class="ew-sb__info"><div class="ew-sb__name"></div>' +
          '<div class="ew-sb__meta"><span class="ew-sb__colour"></span>' +
          (rating ? '<span class="ew-sb__dot"></span><span><span class="ew-sb__stars">★★★★★</span> ' + txt(rating) + '</span>' : '') +
          '</div></div>' +
        (trustTxt ? '<span class="ew-sb__trust"><i></i>' + trustTxt + '</span>' : '') +
        '<div class="ew-sb__price"><span class="ew-sb__now"></span><s class="ew-sb__was"></s><span class="ew-sb__save"></span></div>' +
        '<button type="button" class="ew-sb__btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><span>' + label + '</span></button>' +
      '</div>';
    document.body.appendChild(bar);

    var img = bar.querySelector('.ew-sb__img img');
    var btn = bar.querySelector('.ew-sb__btn');

    function sync() {
      bar.querySelector('.ew-sb__name').textContent = txt(pdp.querySelector('h1'));
      var leg = pdp.querySelector('.ew-sw legend b');
      bar.querySelector('.ew-sb__colour').textContent = leg ? txt(leg) : '';
      bar.querySelector('.ew-sb__now').textContent = txt(pdp.querySelector('.ew-price__now'));
      var was = pdp.querySelector('.ew-price__was');
      bar.querySelector('.ew-sb__was').textContent = was ? txt(was) : '';
      var badge = pdp.querySelector('.ew-price__badge');
      var pct = badge ? (txt(badge).match(/\d+\s*%/) || [''])[0] : '';
      var sv = bar.querySelector('.ew-sb__save');
      sv.textContent = pct ? '−' + pct.replace(/\s/g, '') : '';
      sv.style.display = pct ? '' : 'none';
      var th = Array.prototype.find.call(pdp.querySelectorAll('.ew-gallery__thumb[data-type="image"]'), function (t) { return t.style.display !== 'none'; });
      var src = th ? th.dataset.src : '';
      if (!src) { var i0 = pdp.querySelector('.ew-gallery__main img'); src = i0 ? i0.currentSrc || i0.src : ''; }
      if (src && img.dataset.s !== src) { img.dataset.s = src; img.src = src.replace(/width=\d+/, 'width=200'); }
      btn.disabled = main.disabled;
      btn.querySelector('span').textContent = main.disabled ? (txt(main.querySelector('span')) || 'Sold out') : label;
    }

    btn.addEventListener('click', function () { if (!main.disabled) main.click(); });

    var visible = false;
    function show(on) {
      if (on === visible) return; visible = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) sync();
    }
    function check() {
      var r = buy.getBoundingClientRect();
      var foot = document.querySelector('.ew-footer, footer');
      var nearFoot = foot && foot.getBoundingClientRect().top < window.innerHeight - 40;
      show(r.bottom < 0 && !nearFoot);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    new MutationObserver(function () { if (visible) sync(); }).observe(pdp, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'disabled'] });
    sync(); check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();